// libs
import { styled } from '@nykaa/ui-components';

// mixins
import { resetButton } from 'shared/styles/mixin';

// constants
import { DWEB_MAX_WIDTH, COLORS } from 'shared/styles/base';

export const PromoBannerContainer = styled.div`
  .sub-icons {
    display: flex;
  }

  .app-download {
    width: 124px;
  }

  .appliedCurrency {
    ${resetButton}
    position: absolute;
    left: calc(50% - ${DWEB_MAX_WIDTH / 2}px);
    cursor: pointer;
    color: #fff;
    .down {
      display: inline-block;
      height: 10px;
      width: 10px;
      position: relative;
      margin: 0 5px;
      &:before {
        content: '';
        border: 1px solid #fff;
        height: 5px;
        width: 5px;
        border-color: transparent #fff #fff transparent;
        transform: rotate(45deg);
        position: absolute;
        left: 0;
        top: 0;
      }
    }
  }
  .header-logo-svg {
    margin-bottom: 10px;
  }
`;

export const Banner = styled.div`
  ${({ theme }) => theme.typography.bodySmall};
  height: 32px;
  color: #fff;
  background: ${COLORS.BLACK_100};
  position: relative;
  text-decoration: none;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BannerSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0px 48px;
`;

export const Icon = styled.button`
  background: none;
  outline: 0;
  border: 0;
  color: #fff;
  cursor: pointer;
  margin-left: 24px;
  &:first-child {
    margin: 0;
  }
  display: flex;
  justify-content: center;
  align-items: center;

  i {
    font-size: 20px;
    margin-right: 8px;
    position: relative;
    top: -1px;
  }
`;

export const DownArrow = styled.div`
  display: inline-block;
  height: 10px;
  width: 10px;
  position: relative;
  margin: 0 5px;
  &:before {
    content: '';
    border: 1px solid #fff;
    height: 3px;
    width: 3px;
    border-color: transparent #fff #fff transparent;
    transform: rotate(45deg);
    position: absolute;
    left: 0;
    top: 0;
  }
`;
